<template>
  <div v-if="room !== null" class="acc_detail_modal_unit_or_room_info">
    <ClientOnly>
      <RoomMainImageSlider :item="room" :room="room"/>
      <template slot="fallback">
        <div class="temp-content-card"></div>
      </template>
    </ClientOnly>
    <div class="acc_detail_modal_room_info">
      <p class="title">{{ room.title }}</p>
      <p><Room_beds_description :room="room"/></p>
      <div class="col-12" v-if="room.small_description > 0">
        <p class="h5">{{ $t('room-description') }}</p>
        <p>{{ room.small_description }}</p>
      </div>
      <p class="equipment-title" v-if="room.equipment > 0">{{ $t('room-equipment') }}</p>
      <div class="equipments-group">
          <ul class="equipments" v-for="(group, index) in equipmentGroups" :key="index">
            <li v-for="equip in group" :key="equip" class="equipment">{{ $t('equipment-' + equip) }}</li>
          </ul>
      </div>
      <div class="d-none" v-if="room.getAvailableBedsCount() > 0">
        <p>{{ $t('beds-count') }}</p>
        <Room_beds_description :room="room"/>
      </div>
    </div>
  </div>





  <div v-else class="acc_detail_modal_unit_or_room_info">


    <div class="modal-units acc_detail_modal_unit_info">

     <div class="col-12">
       <ClientOnly>
         <UnitTopImageSlider :room="room" :unit="unit"/>
       </ClientOnly>
     </div>
      <div class="col-12 ">
        <h2 class="h3 title">{{ unit.title }} <span v-if="unit.duplicate_count > 0">{{ unit.duplicate_count }}x</span></h2>

        <p>{{ unit.small_description }}</p>
        <p>{{ unit.description }}</p>
        <p class="small first-color">{{ unit.rooms.length }}&nbsp;{{ $t($vysklonujSlovo('izba', unit.rooms.length, 'y', 'ieb')) }}</p>
      </div>

      <div class="col-12 top" v-if="topEquipments.length > 1">
          <div class="top" v-for="equipment in topEquipments">
            <TyIcon :icon="`ty-${equipment}`" width="1.5rem" height="1.5rem" class="fw-normal"/>
            <span class="fw-normal">{{ $t('equipment-' + equipment) }}</span>
          </div>
      </div>

      <div class="col-12">
        <div class="row">
          <template v-for="room in unit.rooms">

            <div class="col-12 col-lg-4">
              <h4 class="h5 mt-md-3 mb-3">{{ $t('room-type-' + room.type) }}</h4>
              <ClientOnly>
                <UnitRoomImageSlider :room="room"/>
                <template slot="fallback">
                  <div class="temp-content-card"></div>
                </template>
              </ClientOnly>

              <div class="col-12" v-if="room.getAvailableBedsCount(null)">
                <span class="h5 mb-2">{{ $t('beds') }}</span>
                <Room_beds_description :room="room"/>
              </div>

              <div class="col-12" v-if="room.small_description.length > 0">
                <p class="title">{{ $t('small-description') }}</p>
                <p class="text-muted">{{ room.small_description }}</p>
              </div>

              <!-- <div class="col-12" v-if="room.equipment && room.equipment.length > 0">
                <span class="h5 mb-2">{{ $t('equipment') }}</span>
              </div>-->

              <div class="col-12 d-flex align-items-start" v-for="equip in room.equipment">
                <div>
                  <TyIcon icon="ty-check-2" class="icon-color-first pe-2" height="1rem"/>
                </div>
                <div><span>{{ $t('equipment-' + equip) }}</span></div>
              </div>

              <p class="equipment-title" v-if="room.equipment && room.equipment.length > 0">{{ $t('equipment') }}</p>

              <div class="equipments-group">
                <ul class="equipments" v-for="(group, index) in equipmentGroups" :key="index">
                  <li v-for="equip in group" :key="equip" class="equipment">{{ $t('equipment-' + equip) }}</li>
                </ul>
              </div>

            </div>

          </template>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import AccommodationUnit from "~/lib/models/AccommodationUnit";
import AccommodationRoom from "~/lib/models/AccommodationRoom";
import Room_beds_description from "../../../parts/room_beds_description.vue";
import { resolveComponent } from "#imports";

const RoomMainImageSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailModalRoomMainSlider");
const UnitTopImageSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailModalUnitInfoTopImageSlider");
const UnitRoomImageSlider = resolveComponent("LazyWidgetAccommodationDetailAccDetailModalUnitInfoRoomImageSlider");

const props = defineProps({
  unit: Object as PropType<AccommodationUnit>,
  room: Object as PropType<AccommodationRoom>,
});

const topEquipments = computed(() => {
  const top = [
    'wifi', 'tv', 'electric-oven', 'microwave-oven', 'coffee-maker',
    'sauna', 'mini-fridge', 'fridge', 'jacuzzi', 'bathing-tub',
    'iron', 'dishwasher', 'hair-dryer', 'shower-cabin'
  ];
  const eqs = [];
  if (props.unit && props.unit.rooms && props.unit.rooms.length > 0) {
    props.unit.rooms.forEach(room => {
      if (room.equipment && room.equipment.length > 0) {
        room.equipment.forEach(eq => {
          if (top.indexOf(eq) > -1) {
            eqs.push(eq);
          }
        });
      }
    });
  }
  return eqs.slice(0, 4);
});

const equipmentGroups = computed(() => {
  const groups = [];
  if (props.room && props.room.equipment && props.room.equipment.length > 0) {
    for (let i = 0; i < props.room.equipment.length; i += 6) {
      groups.push(props.room.equipment.slice(i, i + 6));
    }
  }
  return groups;
});


</script>
